import { Center } from "@chakra-ui/react";

export default function NotFoundPage() {
    return (
        <Center>
            <h1>Page Not Found</h1>
        </Center>
    )
}